export const ASSISTANT_BUTTON_ID = {
  HOMEPAGE: 'assistant-button-hp',
  DIRECTORY_SECTION: 'assistant-button-directory-section',
  HEADER: 'assistant-button-header',
  FOOTER_1: 'assistant-button-footer-1',
  FOOTER_2: 'assistant-button-footer-2',
  RELATED_TERMS: 'assistant-button-related-terms'
}
